import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, object = user
  const [org, setOrg] = useState(null);
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [emailVerified, setEmailVerified] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrg(data.org);
      setSmsEnabled(!!data.sms_enabled);
      setEmailVerified(data.email_verified !== false);
    } catch {
      setUser(false);
      setOrg(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Fix 9: login/register set an httpOnly cookie server-side. Set user optimistically
  // from the response so route guards don't bounce before /auth/me resolves.
  const applyAuth = (data) => {
    if (data && data.user) setUser(data.user);
    refresh();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Logout request failed:", e); }
    setUser(false);
    setOrg(null);
  };

  return (
    <AuthContext.Provider value={{ user, org, setOrg, applyAuth, logout, refresh, smsEnabled, emailVerified }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
